import { render, staticRenderFns } from "./infoMap.vue?vue&type=template&id=8b94b198&scoped=true"
import script from "./infoMap.vue?vue&type=script&lang=js"
export * from "./infoMap.vue?vue&type=script&lang=js"
import style0 from "./infoMap.vue?vue&type=style&index=0&id=8b94b198&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b94b198",
  null
  
)

export default component.exports